$(function(){
  var utime = "12:00-16:00"; //受付時間
 $(".utime").text(utime);
});

// $('.about4 .f20').on('click', function() {
//     $(this).parent().toggleClass("open");
// });
$(function(){
    //クリックで動く
    $('.about4 .f20').click(function(){
        $(this).parent().toggleClass('open');
        $(this).next('p').slideToggle();
    });
});
$(function(){
    //クリックで動く
    $('.faq .f20').click(function(){
        $(this).parent().toggleClass('close');
        $(this).next('p').slideToggle();
    });
    //ホバーで動く
    // $('.nav-open').hover(function(){
    //     $(this).toggleClass('active');
    //     $(this).next('nav').slideToggle();
    // });
});
$(function(){
    $('.tel_link .tel_link').click(function(){
        $('.tel_link div').addClass('open');
    });
    $('.close-btn').click(function(){
        $('.tel_link div').removeClass('open');
    });
});
$(function () {
  $('.slide-items').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      centerMode: true,
      centerPadding: '0',
  });
});
$(function () {
  $('.top-slide-items').slick({
            autoplay:true,//自動再生する
            autoplaySpeed:2000,//自動再生するスピード 3秒
  });
});
$(function () {
  $('#openModal').click(function(){
      $('#modalArea').fadeIn();
  });
  $('#closeModal , #modalBg').click(function(){
    $('#modalArea').fadeOut();
  });
});

